import { Routes } from '@angular/router';
import { RoutingConfig } from '@app/routing/routing.config';
import { ShellComponent } from './shell.component';

export const ShellRoutes: Routes = [
  { 
    path: '', 
    component: ShellComponent,
    children: [
      {
        path: RoutingConfig.News,
        loadChildren: () => import('@app/modules/news-modules/client/news.module').then((m) => m.NewsModule)
      },
      {
        path: RoutingConfig.Bulletins,
        loadChildren: () => import('@app/modules/bulletins-modules/client/bulletins.module').then((m) => m.BulletinsModule)
      },
      {
        path: RoutingConfig.Account,
        loadChildren: () => import('@app/modules/account-modules/client/account.module').then((m) => m.AccountModule)
      },
      {
        path: RoutingConfig.Market,
        loadChildren: () => import('@app/modules/market-modules/client/market.module').then((m) => m.MarketModule)
      },
      {
        path: RoutingConfig.Calendar,
        loadChildren: () => import('@app/modules/calendar-modules/client/calendar.module').then((m) => m.CalendarModule)
      },
      {
        path: RoutingConfig.Loyalty,
        loadChildren: () => import('@app/modules/loyalty-modules/client/loyalty.module').then((m) => m.LoyaltyModule)
      },
      {
        path: RoutingConfig.Pages,
        loadChildren: () => import('@app/modules/pages-modules/client/pages.module').then((m) => m.PagesModule)
      },
      {
        path: RoutingConfig.Admin,
        loadChildren: () => import('@app/modules/account-admin-modules/client/account-admin.module').then((m) => m.AccountAdminModule)
      }
    ]
  }
];
